import { useEffect } from 'react'
import { TrackEvent, useTracking } from './common/tracking'

export const useTrackRoomSessionOpened = (page: string, roomId?: string, sessionId?: string) => {
  const { trackingClient } = useTracking()

  useEffect(() => {
    if (!roomId || !sessionId) {
      return
    }

    if (page === 'loading') {
      return
    }

    trackingClient.track({
      eventName: TrackEvent.ROOM_SESSION_OPENED,
      eventDetails: {
        roomId,
        sessionId,
        page,
      },
    })
  }, [page, roomId, sessionId, trackingClient])
}
